export default "__VITE_ASSET__ClISR6Od__"